<template>
  <div class="summary">
    <div v-for="(item, i) in list" :key="item.label + i" class="item" @click="handleLink(item.route)">
      <div class="top">
        <div class="icon">
          <img :src="item.icon" alt="" />
        </div>
        <div>
          <div class="label">{{ item.label }}</div>
          <div class="num text-num">{{ numObj[item.value] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import themeVarsDefine from '@/mixins/themeVarsDefine'
import chainHeightLightIcon from '@/assets/images/home/chain-height.png'
import chainTranscationNumLightIcon from '@/assets/images/home/chain-transcation-num.png'
import chainContractNumLightIcon from '@/assets/images/home/chain-contract-num.png'
import chainOrgNumLightIcon from '@/assets/images/home/chain-org-num.png'
import chainNodeNumLightIcon from '@/assets/images/home/chain-node-num.png'
import chainUserNumLightIcon from '@/assets/images/home/chain-height.png'
import chainHeightDarkIcon from '@/assets/images/home/dark/chain-height.png'
import chainTranscationNumDarkIcon from '@/assets/images/home/dark/chain-transcation-num.png'
import chainContractNumDarkIcon from '@/assets/images/home/dark/chain-contract-num.png'
import chainOrgNumDarkIcon from '@/assets/images/home/dark/chain-org-num.png'
import chainNodeNumDarkIcon from '@/assets/images/home/dark/chain-node-num.png'
import chainUserNumDarkIcon from '@/assets/images/home/dark/chain-height.png'
export default {
  name: 'SummaryData',
  mixins: [themeVarsDefine],
  themeVarsDefine: {
    dark: {
      chainHeightIcon: chainHeightDarkIcon,
      chainTranscationNumIcon: chainTranscationNumDarkIcon,
      chainContractNumIcon: chainContractNumDarkIcon,
      chainOrgNumIcon: chainOrgNumDarkIcon,
      chainNodeNumIcon: chainNodeNumDarkIcon,
      chainUserNumIcon: chainUserNumDarkIcon
    },
    default: {
      chainHeightIcon: chainHeightLightIcon,
      chainTranscationNumIcon: chainTranscationNumLightIcon,
      chainContractNumIcon: chainContractNumLightIcon,
      chainOrgNumIcon: chainOrgNumLightIcon,
      chainNodeNumIcon: chainNodeNumLightIcon,
      chainUserNumIcon: chainUserNumLightIcon
    }
  },
  data() {
    return {
      themeVars: {},
      list: [
        {
          label: '区块高度',
          icon: chainHeightDarkIcon,
          value: 'blockHeight',
          route: 'blockInfo'
        },
        {
          label: '累计交易数',
          icon: chainTranscationNumDarkIcon,
          value: 'transactionNum',
          route: 'transactionInfo'
        },
        {
          label: '累计合约数',
          icon: chainContractNumDarkIcon,
          value: 'contractNum',
          route: 'contractInfo'
        },
        {
          label: '组织数',
          icon: chainOrgNumDarkIcon,
          value: 'orgNum',
          route: 'organizationInfo'
        },
        {
          label: '节点数',
          icon: chainNodeNumDarkIcon,
          value: 'nodeNum',
          route: 'nodeInfo'
        }
      ],
      numObj: {}
    }
  },
  watch: {
    themeVars: function (val) {
      this.list[0].icon = val.chainHeightIcon;
      this.list[1].icon = val.chainTranscationNumIcon;
      this.list[2].icon = val.chainContractNumIcon;
      this.list[3].icon = val.chainOrgNumIcon;
      this.list[4].icon = val.chainNodeNumIcon;
      // this.list[5].icon = val.chainUserNumIcon;
    },
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getData(newValue)
    }
  },
  mounted() {
    let cid = this.$store.state.home.chainCid
    this.getData(cid)
  },
  methods: {
    getData(cid) {
      if (cid) {
        this.$apis.home.getOverview({ cid }).then(res => {
          if (res.data) {
            this.numObj = res.data
          }
        })
      }
    },
    handleLink(link) {
      this.$router.push({
        name: link
      })
    }
  }
}
</script>

<style scoped lang="scss">
.summary {
  display: flex;
  align-items: center;
  height: 100%;

  .item:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  .item {
    width: 20%;
    text-align: center;

    .top {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: var(--home-profile-item-height);
      padding: var(--home-profile-item-padding);

      .icon {
        width: var(--home-profile-icon-size);
        height: var(--home-profile-icon-size);
        margin-right: var(--home-profile-icon-margin-right);
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: var(--home-profile-icon-size);
          height: var(--home-profile-icon-size);
        }
      }

      .num {
        margin-top: var(--home-profile-num-margin-top);
        color: var(--home-profile-num-color);
        font-size: var(--home-profile-num-font-size);
        height: var(--home-profile-num-height);
        text-align: left;
        font-style: normal;
        font-weight: 500;
        line-height: var(--home-profile-num-height);
      }
    }

    .label {
      color: var(--home-profile-name-color);
      font-size: var(--home-profile-name-font-size);
      height: var(--home-profile-name-height);
      font-style: normal;
      font-weight: 350;
      line-height: var(--home-profile-name-height);
    }
  }
}
</style>
